import { useState, useEffect } from "react";
import Select from 'react-select';
import { ddStyles } from "../utils/CommonStyles.js";

let supplierDateOptions = [];
let defaultSupplierDateOptions = [];
const SupplierProductReadOnlyRow = ({ key, t, supplierDates, partnerProductItem, handleDeleteClick, oddIdx, add, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);
	const [isEditMode, setIsEditMode] = useState(false);
	const [supplierDateLoaded, setSupplierDateLoaded] = useState(false);
    const [supplierDatesSelected, setSupplierDatesSelected] = useState([]);

	useEffect(() => {
		 setSupplierDates(supplierDates);
	}, []);
	
	function setSupplierDates(supplierDateList) {
        let supplierDateValue = {};
        supplierDateOptions = [];
        defaultSupplierDateOptions = [];
        if (supplierDateList && supplierDateList.length > 0) {
            supplierDateList.map((aSupplierDate, idx) => {
				supplierDateValue.label = aSupplierDate.startDate + " - " + aSupplierDate.endDate;
                supplierDateValue.value = aSupplierDate.partnershipDateKey;
				 if (partnerProductItem.supplierDates && partnerProductItem.supplierDates.length > 0) {
            		partnerProductItem.supplierDates.map((eachSupplierDate) => {
						if(aSupplierDate.partnershipDateKey == eachSupplierDate.partnershipDateKey){
							defaultSupplierDateOptions.push(supplierDateValue);
							return null;
						}
				 	});
				 }
                supplierDateOptions.push(supplierDateValue);
                supplierDateValue = {};
            });
            setSupplierDateLoaded(true);
            setSupplierDatesSelected(defaultSupplierDateOptions);
        }
    }
    const supplierDateHandler = (selectedOptions) => {
        setSupplierDatesSelected(selectedOptions);
    }
	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, partnerProductItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, partnerProductItem, submitComplete);
	}
	function handleEditClick(event) {
        //event.preventDefault();
        //event.stopPropagation();
        setIsSubmit(false);
        setIsEditMode(true);
        setSupplierDates(supplierDates);
    }

    function submitUpdate(event, partnerProductItem) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsSubmit(true);
        let updatedValues = {
            companyProductKey: partnerProductItem.companyProductKey,
            partnershipDateKeys: supplierDatesSelected.map(option => option.value),
        };
        handleSubmit(2, updatedValues, submitUpdateComplete);
    }

    function submitUpdateComplete() {
        setIsSubmit(false);
        setIsEditMode(false);
    }

    function submitCancel(event) {
        //event.preventDefault();
        //event.stopPropagation();
        setError("");
        setIsEditMode(false);
        setIsSubmit(false);
    }

	return (
		<tr key={key}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerProductItem.productGroupName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerProductItem.commodityName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerProductItem.productName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerProductItem.productSku}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerProductItem.description}</td>
			{isEditMode ? (
                <>
                    <td className={oddIdx ? "list-td col odd" : "list-td col even"}>
		                {supplierDateLoaded ? <Select
		                    name="supplierDateKey"
		                    options={supplierDateOptions}
		                    onChange={supplierDateHandler}
		                    placeholder={""}
		                    value={supplierDatesSelected}
		                    isSearchable={true}
		                    isClearable={true}
		                    className="myselect"
		                    inputId="supplierDateKey-input"
		                    isMulti
		                    styles={ddStyles}
		                />
	                    : <></>}
                	</td>
                </>
            ) : (
                <>
                    <td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{partnerProductItem.supplierDateString}</td>
                </>
            )
            }
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{partnerProductItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				{isEditMode ? (
                    <>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 pe-none" : "btn btn-primary btn-block me-2"}
                            onClick={(event) => submitUpdate(event, partnerProductItem)}>{t("page.submit")}</button>
                        <button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block me-4"}
                            onClick={(event) => (submitCancel(event))}>{t("page.cancel")}</button>
                    </>
                ) : (
					<>
                        <button className={isSubmit ? "btn btn-primary btn-block me-2 pe-none" : "btn btn-primary btn-block me-2"}
                            onClick={(event) => handleEditClick(event)}>{t("page.edit")}</button>
                       <button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, partnerProductItem)}>
							{partnerProductItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
                    </>
                )}
				
			</td>
		</tr>
	)
}
export default SupplierProductReadOnlyRow;